export default "__VITE_ASSET__D6Sxw2Yc__"